import {isEmpty} from 'lodash/lang';
import request from './base';
import {excludeObjNullValue} from 'utils/common';

/**
 * message endpoints
 */
export const fetchMessages = (q, page, perPage, sortOpts, extraParams) =>
  request.fetchList('/messages', q, page, perPage, sortOpts, extraParams).then(({pageCount, recordCount, records}) => ({
    pageCount,
    recordCount,
    records: records.map((record) =>
      record.readAt !== undefined
        ? {
            ...record.message,
            readAt: record.readAt,
            userId: record.userId,
          }
        : record,
    ),
  }));

export const fetchMessage = (messageId) => request.fetchDetail(`/messages/${messageId}`);

export const createMessage = (payload) =>
  request.postJSON(
    '/messages',
    excludeObjNullValue({
      body: payload.body,
      receiver_role: payload.receiverRole,
      receiver_school_id: payload.receiverSchoolId,
      receiver_id: payload.receiverId,
      level: payload.level,
      state: payload.state,
      country: payload.country,
      receiver_ids: payload.receiverIds,
      receiver_classroom_ids: payload.receiverClassroomIds,
    }),
  );

export const fetchUnreadMessageCnt = () => request.getJSON('/messages/unread-cnt');

export const markMessageAsRead = (messageId) => request.putJSON(`/messages/${messageId}/mark-as-read`);
